(() => {
  const active = new WeakSet();
  const qs = (root, selector) => root.querySelector(selector);
  const setText = (node, text) => { if (node) node.textContent = text == null ? '' : String(text); };
  const supportsMotion = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const skipPage = () => {
    if (document.documentElement.classList.contains('rpull-skip')) return true;
    return Array.from(new URLSearchParams(location.search)).some(([k,v]) => {
      if (k === 'filter.v.availability' && v === '1') return false;
      if (k === 'sort_by' || k === 'preview_theme_id') return false;
      if (k === 'page' || k === 'ravin_page') return Number(v) > 1;
      return k.startsWith('page_') || k.startsWith('filter.') || k.startsWith('ravin.price.');
    });
  };
  const sheetHeading = root => {
    const wrapper = document.createElement('div');
    wrapper.className = 'rpull-sheet-top';
    wrapper.innerHTML = '<button type="button" class="rpull-tab" data-rpull-tab aria-label="Pull up to explore collection"><span class="rpull-grip" aria-hidden="true"></span><span class="rpull-tab-row"><span>THE COLLECTION / THE EDIT</span><span class="rpull-tab-call">PULL TO EXPLORE <span aria-hidden="true">↑</span></span></span></button><div class="rpull-feed-heading"><div><div class="rpull-feed-kicker">RAVIN / SHOP THE EDIT</div><h2 data-rpull-collection-heading>WOMEN’S SALE</h2></div><span class="rpull-feed-meta" data-rpull-items></span></div><div class="rpull-feature-line"><span data-rpull-feature-title></span><strong data-rpull-feature-price></strong></div><div class="rpull-view-switch"><span class="rpull-view-label">VIEW / LAYOUT</span><div class="rpull-toggle" role="group" aria-label="Products per row"><button type="button" data-rpull-one aria-pressed="true" aria-label="One product per row">01</button><button type="button" data-rpull-two aria-pressed="false" aria-label="Two products per row">02</button></div></div>';
    setText(qs(wrapper,'[data-rpull-collection-heading]'),root.dataset.rpullCollectionName||'The Collection');
    const isSearch = root.dataset.rpullContext === 'search';
    const count = Number(root.dataset.rpullCollectionSize);
    setText(qs(wrapper,'[data-rpull-items]'),isSearch ? count.toLocaleString('en-EG') + ' RESULTS' : (count > 0 ? count.toLocaleString('en-EG') + ' STYLES' : 'THE COLLECTION'));
    if(isSearch || root.dataset.rpullImageSource==='collection'){
      qs(wrapper,'.rpull-feature-line')?.remove();
    }else{
      setText(qs(wrapper,'[data-rpull-feature-title]'),root.dataset.rpullProductTitle||'THE FIRST LOOK');
      setText(qs(wrapper,'[data-rpull-feature-price]'),root.dataset.rpullProductPrice||'');
    }
    if (isSearch) {
      qs(wrapper,'.rpull-tab-row > span:first-child').textContent='SEARCH / THE EDIT';
      qs(wrapper,'.rpull-tab-call').textContent='PULL TO EXPLORE ↑';
      qs(wrapper,'.rpull-feed-kicker').textContent='RAVIN / SEARCH RESULTS';
      qs(wrapper,'[data-rpull-tab]').setAttribute('aria-label','Pull up to explore search results');
    }
    if ((document.documentElement.lang || '').toLowerCase().startsWith('ar')) {
      wrapper.setAttribute('dir','rtl');
      const replaceLabel=(selector,text)=>{ const element=wrapper.querySelector(selector); if(element)element.textContent=text; };
      replaceLabel('.rpull-tab-row > span:first-child','المجموعة / مختارات ريفين');
      replaceLabel('.rpull-tab-call','اسحب لفوق واكتشف ↑');
      replaceLabel('.rpull-feed-kicker','ريفين / اكتشف المجموعة');
      replaceLabel('.rpull-view-label','طريقة العرض');
      if (isSearch) {
        replaceLabel('.rpull-tab-row > span:first-child','البحث / مختارات ريفين');
        replaceLabel('.rpull-tab-call','اسحب لفوق وشوف النتائج ↑');
        replaceLabel('.rpull-feed-kicker','ريفين / نتائج البحث');
        qs(wrapper,'[data-rpull-tab]').setAttribute('aria-label','اسحب لفوق لاستكشاف نتائج البحث');
      }
      const tab=wrapper.querySelector('[data-rpull-tab]');
      if(tab)tab.setAttribute('aria-label','اسحب لفوق لاستكشاف المجموعة');
      const toggle=wrapper.querySelector('.rpull-toggle');
      if(toggle)toggle.setAttribute('aria-label','عدد المنتجات في الصف');
      const one=wrapper.querySelector('[data-rpull-one]');
      const two=wrapper.querySelector('[data-rpull-two]');
      if(one)one.setAttribute('aria-label','قطعة واحدة في الصف');
      if(two)two.setAttribute('aria-label','قطعتان في الصف');
      const countLabel=wrapper.querySelector('[data-rpull-items]');
      if(countLabel&&(count>0 || isSearch))countLabel.textContent=count.toLocaleString('ar-EG')+(isSearch ? ' نتيجة' : ' قطعة');
    }
    return wrapper;
  };
  function init(root) {
    if (active.has(root) || skipPage()) return;
    const main = root.closest('#MainContent');
    const customResults = main && qs(main, '[data-ravin-results-root]');
    const nativeGrid = !customResults && main && qs(main, '#product-grid');
    const grid = customResults ? qs(customResults,'[data-ravin-price-grid]') : nativeGrid;
    const host = (customResults || nativeGrid)?.closest('.shopify-section');
    const results = customResults || host;
    if (!main || !results || !host || !grid) return;
    active.add(root);
    main.classList.add('rpull-active');
    host.classList.add('rpull-sheet-host');
    if (nativeGrid) {
      const oldBanner = main.querySelector('.collection-hero')?.closest('.shopify-section');
      if (oldBanner && oldBanner !== host) oldBanner.classList.add('rpull-suppressed-banner');
    }
    const sheet = sheetHeading(root);
    results.prepend(sheet);
    let columns = 1;
    try { columns = localStorage.getItem('ravin-pull-grid-columns') === '2' ? 2 : 1; }
    catch(e) {}
    const one = qs(sheet,'[data-rpull-one]'), two=qs(sheet,'[data-rpull-two]');
    const setColumns = next => {
      columns = next;
      main.classList.toggle('rpull-two',next===2);
      one.setAttribute('aria-pressed',String(next===1));
      two.setAttribute('aria-pressed',String(next===2));
      try { localStorage.setItem('ravin-pull-grid-columns',String(next)); } catch(e) {}
    };
    setColumns(columns);
    one.addEventListener('click',()=>setColumns(1));
    two.addEventListener('click',()=>setColumns(2));
    const openSheet = () => host.scrollIntoView({behavior:supportsMotion()?'smooth':'instant',block:'start'});
    qs(sheet,'[data-rpull-tab]').addEventListener('click',openSheet);
    qs(root,'[data-rpull-open-sheet]')?.addEventListener('click',openSheet);
    const cards = () => Array.from(grid.querySelectorAll('a[data-product-card]'));
    const decorate = () => {
      cards().forEach(card => {
        if (qs(card,'.rpull-card-pill')) return;
        const media = card.querySelector('[class*="ai-product-image-wrapper-"]');
        if (!media) return;
        const label = document.createElement('span');
        label.className='rpull-card-pill';
        label.setAttribute('aria-hidden','true');
        label.textContent=(document.documentElement.lang||'').toLowerCase().startsWith('ar')?'شوف القطعة ↗':'VIEW PRODUCT ↗';
        media.appendChild(label);
      });
    };
    decorate();
    const observer = new MutationObserver(decorate);
    observer.observe(grid,{childList:true,subtree:false});
    document.addEventListener('shopify:section:unload',event=>{
      if(event.target.contains(root)){observer.disconnect();active.delete(root);}
    });
  }
  const mount = scope => {
    if(scope.matches?.('[data-rpull-cover]'))init(scope);
    scope.querySelectorAll?.('[data-rpull-cover]').forEach(init);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});
  else mount(document);
  document.addEventListener('shopify:section:load',event=>mount(event.target));
})();